(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion-faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const items = document.querySelectorAll('.faq-accordion-item');
  
      items.forEach(item => {
        const answer = item.querySelector('.faq-accordion-answer');
        if (item.classList.contains('active')) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
  
      items.forEach(item => {
        const question = item.querySelector('.faq-accordion-question');
        const answer = item.querySelector('.faq-accordion-answer');
  
        question.addEventListener('click', () => {
          const isActive = item.classList.contains('active');
  
  
          items.forEach(i => {
            const a = i.querySelector('.faq-accordion-answer');
            if (i !== item) {
              i.classList.remove('active');
              a.style.maxHeight = null;
            }
          });
  
  
          if (isActive) {
            item.classList.remove('active');
            answer.style.maxHeight = null;
          } else {
            item.classList.add('active');
            answer.style.maxHeight = answer.scrollHeight + "px";
          }
        });
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion-form-test"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const accordionHeaders = document.querySelectorAll('.accordion-header');
  
      accordionHeaders.forEach((header) => {
        header.addEventListener('click', () => {
          const isActive = header.classList.contains('active');
          const content = header.nextElementSibling;
  
          // Close all accordions
          accordionHeaders.forEach((h) => {
            const otherContent = h.nextElementSibling;
            if (h !== header) {
              h.classList.remove('active');
              h.setAttribute('aria-expanded', 'false');
              otherContent.style.maxHeight = '0px';
              otherContent.classList.remove('active');
            }
          });
  
          // Toggle clicked accordion
          if (!isActive) {
            header.classList.add('active');
            header.setAttribute('aria-expanded', 'true');
            content.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            header.classList.remove('active');
            header.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0px';
            content.classList.remove('active');
          }
        });
      });
    });
  
    // Google Drive upload integration
    const fileInputGDrive = document.getElementById('file-upload');
    const fileLinkInput = document.getElementById('file-link');
    const uploadStatus = document.getElementById('upload-status');
    if (fileInputGDrive) {
      fileInputGDrive.addEventListener('change', async function(e) {
        const file = e.target.files[0];
        if (!file) return;
        uploadStatus.textContent = 'Uploading...';
        const reader = new FileReader();
        reader.onload = async function(evt) {
          const base64 = evt.target.result.split(',')[1];
          const data = {
            filedata: base64,
            filename: file.name,
            mimetype: file.type
          };
          // Replace YOUR_WEB_APP_URL with your actual Google Apps Script web app URL
          const res = await fetch('https://script.google.com/macros/s/AKfycbzgAnUkIX58FhseQpFHoIJdtq9tCGSQv_MwJa2uxZWOLu3E1AOrTrUHLbhCcOXS5-b2aQ/exec', {
            method: 'POST',
            body: new URLSearchParams(data)
          });
          const json = await res.json();
          if (json.url) {
            fileLinkInput.value = json.url;
            uploadStatus.textContent = 'Upload complete!';
          } else {
            uploadStatus.textContent = 'Upload failed: ' + (json.error || 'Unknown error');
          }
        };
        reader.readAsDataURL(file);
      });
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion-form-v1"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const accordionHeaders = document.querySelectorAll('.accordion-header');
  
      accordionHeaders.forEach((header) => {
        header.addEventListener('click', () => {
          const isActive = header.classList.contains('active');
          const content = header.nextElementSibling;
  
          // Close all accordions
          accordionHeaders.forEach((h) => {
            const otherContent = h.nextElementSibling;
            if (h !== header) {
              h.classList.remove('active');
              h.setAttribute('aria-expanded', 'false');
              otherContent.style.maxHeight = '0px';
              otherContent.classList.remove('active');
            }
          });
  
          // Toggle clicked accordion
          if (!isActive) {
            header.classList.add('active');
            header.setAttribute('aria-expanded', 'true');
            content.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            header.classList.remove('active');
            header.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0px';
            content.classList.remove('active');
          }
        });
      });
    });
  
    // Google Drive upload integration
    const fileInputGDrive = document.getElementById('file-upload');
    const fileLinkInput = document.getElementById('file-link');
    const uploadStatus = document.getElementById('upload-status');
    if (fileInputGDrive) {
      fileInputGDrive.addEventListener('change', async function(e) {
        const file = e.target.files[0];
        if (!file) return;
        uploadStatus.textContent = 'Uploading...';
        const reader = new FileReader();
        reader.onload = async function(evt) {
          const base64 = evt.target.result.split(',')[1];
          const data = {
            filedata: base64,
            filename: file.name,
            mimetype: file.type
          };
          // Replace YOUR_WEB_APP_URL with your actual Google Apps Script web app URL
          const res = await fetch('https://script.google.com/macros/s/AKfycbzgAnUkIX58FhseQpFHoIJdtq9tCGSQv_MwJa2uxZWOLu3E1AOrTrUHLbhCcOXS5-b2aQ/exec', {
            method: 'POST',
            body: new URLSearchParams(data)
          });
          const json = await res.json();
          if (json.url) {
            fileLinkInput.value = json.url;
            uploadStatus.textContent = 'Upload complete!';
          } else {
            uploadStatus.textContent = 'Upload failed: ' + (json.error || 'Unknown error');
          }
        };
        reader.readAsDataURL(file);
      });
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-accordion-form"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
      const accordionHeaders = document.querySelectorAll('.accordion-header');

      // Initialize accordion items that should be open by default
      accordionHeaders.forEach((header) => {
        const content = header.nextElementSibling;
        if (header.classList.contains('active') && content.classList.contains('active')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });

      accordionHeaders.forEach((header) => {
        header.addEventListener('click', () => {
          const isActive = header.classList.contains('active');
          const content = header.nextElementSibling;
  
          // Close all accordions
          accordionHeaders.forEach((h) => {
            const otherContent = h.nextElementSibling;
            if (h !== header) {
              h.classList.remove('active');
              h.setAttribute('aria-expanded', 'false');
              otherContent.style.maxHeight = '0px';
              otherContent.classList.remove('active');
            }
          });
  
          // Toggle clicked accordion
          if (!isActive) {
            header.classList.add('active');
            header.setAttribute('aria-expanded', 'true');
            content.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            header.classList.remove('active');
            header.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0px';
            content.classList.remove('active');
          }
        });
      });
    });
  
    const fileInput = document.getElementById('file-upload');
    const fileUploadButton = document.querySelector('.file-upload-button');
    const fileNameDisplay = document.querySelector('.file-name-display');

    fileInput.addEventListener('change', (event) => {
      if (event.target.files.length > 0) {
        const fileName = event.target.files[0].name;
        fileUploadButton.innerHTML = fileName + ' <span class="icon-upload"></span>';
        fileNameDisplay.textContent = '';
      } else {
        fileUploadButton.innerHTML = 'Upload Images* <span class="icon-upload"></span>';
        fileNameDisplay.textContent = '';
      }
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-one-old"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const featureList = document.querySelector(".feature-list");
  const featureItems = document.querySelectorAll(".feature-item");
  const totalSlides = featureItems.length;

  let currentIndex = 0;
  let direction = 1; // 1 = forward, -1 = backward
  let interval;

  function moveSlide() {
    if (window.innerWidth <= 768) {
      featureList.style.transform = `translateX(-${currentIndex * 100}%)`;
      currentIndex += direction;
      if (currentIndex === totalSlides - 1 || currentIndex === 0) {
        direction *= -1;
      }
    }
  }

  function startSlider() {
    if (window.innerWidth <= 768 && !interval) {
      interval = setInterval(moveSlide, 2000);
    } else if (window.innerWidth > 768 && interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  // Start or stop the slider based on screen width
  startSlider();
  window.addEventListener("resize", startSlider);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-one"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    // Dynamically set --orbit-size based on the container's width (desktop only)
    function setOrbitSize() {
      const container = document.querySelector('.section--hero-one-container');
      const root = document.documentElement;
      if (!container) {
        root.style.removeProperty('--orbit-size');
        return;
      }
      if (window.innerWidth > 980) {
        // Desktop: clamp between 980px and 1200px
        const containerWidth = container.offsetWidth;
        const orbitSize = Math.max(1200, Math.min(containerWidth * 0.9, 1350));
        root.style.setProperty('--orbit-size', orbitSize + 'px');
      } else if (window.innerWidth >= 768 && window.innerWidth <= 980) {
        // Tablet: clamp between 600px and 900px
        const containerWidth = container.offsetWidth;
        const orbitSize = Math.max(1080, Math.min(containerWidth * 0.85, 1200));
        root.style.setProperty('--orbit-size', orbitSize + 'px');
      } else {
        // Remove the variable for mobile
        root.style.removeProperty('--orbit-size');
      }
    }

    setOrbitSize();
    window.addEventListener('resize', setOrbitSize);

    // ...existing code for feature slider and mobile slider pop effect...
    const featureList = document.querySelector(".feature-list");
    const featureItems = document.querySelectorAll(".feature-item");
    const totalSlides = featureItems.length;

    let currentIndex = 0;
    let direction = 1; // 1 = forward, -1 = backward
    let interval;

    function moveSlide() {
      if (window.innerWidth <= 980) {
        featureList.style.transform = `translateX(-${currentIndex * 100}%)`;
        currentIndex += direction;
        if (currentIndex === totalSlides - 1 || currentIndex === 0) {
          direction *= -1;
        }
      }
    }

    function startSlider() {
      if (window.innerWidth <= 980 && !interval) {
        featureList.style.transform = `translateX(-${currentIndex * 100}%)`;
        interval = setInterval(moveSlide, 2000);
      } else if (window.innerWidth > 980) {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
        featureList.style.transform = ""; // <-- Reset transform on desktop
      }
    }

    // Start or stop the slider based on screen width
    startSlider();
    window.addEventListener("resize", startSlider);

    // Mobile slider pop effect (carousel/coverflow style)
    setTimeout(() => {
      const mobileSliderImages = document.querySelectorAll('.mobile-slider-image');
      let activeIndex = 0;
      function setActiveMobileSliderImage(idx) {
        mobileSliderImages.forEach((img, i) => {
          img.classList.remove('prev', 'active', 'next');
          if (i === idx) {
            img.classList.add('active');
          } else if (i === (idx - 1 + mobileSliderImages.length) % mobileSliderImages.length) {
            img.classList.add('prev');
          } else if (i === (idx + 1) % mobileSliderImages.length) {
            img.classList.add('next');
          }
        });
      }
      if (mobileSliderImages.length > 0) {
        setActiveMobileSliderImage(activeIndex);
        setInterval(() => {
          activeIndex = (activeIndex + 1) % mobileSliderImages.length;
          setActiveMobileSliderImage(activeIndex);
        }, 3000);
      }
    }, 300);
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-text-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  accordionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      const isActive = header.classList.contains('active');
      const content = header.nextElementSibling;

      // Close all accordions
      accordionHeaders.forEach((h) => {
        const otherContent = h.nextElementSibling;
        if (h !== header) {
          h.classList.remove('active');
          h.setAttribute('aria-expanded', 'false');
          otherContent.style.maxHeight = '0px';
          otherContent.classList.remove('active');
        }
      });

      // Toggle clicked accordion
      if (!isActive) {
        header.classList.add('active');
        header.setAttribute('aria-expanded', 'true');
        content.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        header.classList.remove('active');
        header.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = '0px';
        content.classList.remove('active');
      }
    });
  });

  // Phone input mask (US format: (XXX) XXX-XXXX)
  var phoneInput = document.getElementById('phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function(e) {
      var x = phoneInput.value.replace(/\D/g, '').substring(0,10);
      
      if (x.length === 0) {
        phoneInput.value = '';
        return;
      }
      
      // Build the formatted string with underscores for missing digits
      var template = '(___) ___-____';
      var chars = x.split('');
      var positions = [1, 2, 3, 6, 7, 8, 10, 11, 12, 13]; // positions where digits go
      var result = template.split('');
      
      for (var i = 0; i < chars.length && i < positions.length; i++) {
        result[positions[i]] = chars[i];
      }
      
      phoneInput.value = result.join('');
      
      // Set cursor position
      var cursorPos = 1;
      if (chars.length > 0) cursorPos = positions[Math.min(chars.length - 1, positions.length - 1)] + 1;
      if (chars.length >= 3 && cursorPos <= 4) cursorPos = 6;
      if (chars.length >= 6 && cursorPos <= 9) cursorPos = 10;
      
      phoneInput.setSelectionRange(cursorPos, cursorPos);
    });

    phoneInput.addEventListener('keydown', function(e) {
      // Handle backspace
      if (e.key === 'Backspace') {
        e.preventDefault();
        var x = phoneInput.value.replace(/\D/g, '');
        if (x.length > 0) {
          x = x.substring(0, x.length - 1);
          if (x.length === 0) {
            phoneInput.value = '';
          } else {
            // Trigger input event to reformat
            var inputEvent = new Event('input', { bubbles: true });
            phoneInput.value = x;
            phoneInput.dispatchEvent(inputEvent);
          }
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
